import { productTypeFromProductID } from "./productTypes";

// Builds the file name of a test snapshot, for all products:
// date_productType_accountId_installId_number.jpg, for example
// 09-09-2026_TIM-4_19_2025093718_1.jpg.
// The snapshot service takes the S3 key from the form field name, which is
// this file name minus ".jpg" (see AuthService.uploadFileTos3).
export function snapshotFileName({ productId, accountId, installId, snapshotNumber, date = new Date() }) {
    const datePart =
        String(date.getDate()).padStart(2, "0") + "-" +
        String(date.getMonth() + 1).padStart(2, "0") + "-" +
        date.getFullYear();

    // POE product names carry a space, which has no place in an S3 key.
    const productType = productTypeFromProductID(productId).replace(/\s+/g, "-");

    // Some pages carry the device id in its dashed display form (2025-093-718).
    const install = String(installId).replace(/-/g, "");

    return `${datePart}_${productType}_${accountId}_${install}_${snapshotNumber}.jpg`;
}

// floorDetails is an array on some pages and a single floor on others.
export function accountIdFromFloorDetails(floorDetails) {
    const floor = Array.isArray(floorDetails) ? floorDetails[0] : floorDetails;
    return floor?.accountId;
}
